import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import { CardWrapper, CardSection } from '@bibliocommons/base-card';
import ScreenReaderMessage from '@bibliocommons/base-screen-reader-message';
import { RatingStars } from '@bibliocommons/rating';
import SliderJacketCover from '@bibliocommons/shared-slider-jacket-cover';
import { truncate } from '@bibliocommons/utils-string';

import './RatingCard.scss';

const RatingCard = ({ className, item, rating, creator, border, onJacketClick }) => {
  const creatorUrl = `/user_profile/${creator.id}`;

  const label = (
    <FormattedMessage
      id="rated_by"
      values={{
        authorLinks: (
          <>
            <a className="author-links link-solid-true-underline-grey" href={creatorUrl}>
              <div aria-hidden="true">{truncate(creator.name, { desiredLength: 16 })}</div>
              <ScreenReaderMessage>
                <FormattedMessage id="sr_view_profile" values={{ username: creator.name }} />
              </ScreenReaderMessage>
            </a>
          </>
        )
      }}
    />
  );

  const renderProp = sectionClass => (
    <div className={sectionClass}>
      <RatingStars className="rating-stars" rating={rating.rating} />
      {label}
    </div>
  );

  const cardClass = `cp-rating-card ${className}`;

  return (
    <CardWrapper border={border} className={cardClass}>
      <SliderJacketCover handleClick={onJacketClick} item={item} username={creator.name} rating={rating.rating} />
      <CardSection className="rating-body" renderProp={renderProp} />
    </CardWrapper>
  );
};

RatingCard.propTypes = {
  className: PropTypes.string,
  border: PropTypes.bool,
  item: PropTypes.shape({
    id: PropTypes.string.isRequired,
    format: PropTypes.string.isRequired,
    jacket: PropTypes.shape({
      medium: PropTypes.string.isRequired
    }).isRequired,
    title: PropTypes.string.isRequired
  }).isRequired,
  creator: PropTypes.shape({ id: PropTypes.string, name: PropTypes.string }).isRequired,
  onJacketClick: PropTypes.func,
  rating: PropTypes.shape({
    rating: PropTypes.number.isRequired, // integer 0 - 100
    id: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    readOnly: PropTypes.bool,
    metadataId: PropTypes.string
  })
};

RatingCard.defaultProps = {
  border: false,
  onJacketClick: () => {},
  rating: {
    readOnly: true,
    type: 'average'
  }
};

export default RatingCard;
